<template lang="pug">
th.table-header-base.font-bold
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * thタグ
 */
@Component
export default class TableHeaderBase extends Vue {}
</script>

<style lang="stylus" scoped></style>
